import React from 'react';
import flag from './../../../assets/icons/flag.png';
import union from './../../../assets/icons/Union.png';
import {
  CrmChartQuarterlyContainer,
  Bar,
  GapBar,
  CrmChartQuarterlyBar,
  GreenHashBar,
  OrangeHashBar,
  GapBarDashboard,
} from '../../../atoms/sidebar/sidebar.styles';
import { getConvertedPercentageInPx } from '../../../../util/commonUtil';
import { Recoil_Quarter_State } from '../../../../recoil/recoil';
import { useRecoilValue } from 'recoil';

export function CrmChartQuarterly(quarterlyData) {
  const quarterInfo = useRecoilValue(Recoil_Quarter_State);

  let data = quarterlyData.quarterlyData;
  let soldPercentageWidth;
  let soldHashPercentageWidth;
  let commitPercentageWidth;
  let CommitHashPercentageWidth;

  let soldValue = quarterlyData?.quarterlyData?.sold;
  let commitValue = quarterlyData?.quarterlyData?.commit;
  let forecastedValue = quarterlyData?.quarterlyData?.forecast;
  let gapValue;

  if (!!data && data.period == 'past') {
    if (
      quarterInfo.current_month_start_date == quarterInfo.quarter_start_date ||
      quarterInfo.current_month_end_date == quarterInfo.quarter_end_date ||
      (quarterInfo.current_month_start_date > quarterInfo.quarter_start_date &&
        quarterInfo.current_month_start_date < quarterInfo.quarter_end_date)
    ) {
      //current
      gapValue = Math.abs(forecastedValue - commitValue - soldValue);
    } else {
      //past
      gapValue = Math.abs(forecastedValue - soldValue);
      commitValue = 0;
    }
  } else {
    //future
    gapValue = Math.abs(forecastedValue - commitValue - soldValue);
  }

  if (parseFloat(soldValue) + parseFloat(commitValue) > parseFloat(forecastedValue)) {
    gapValue = 0;
  }
  if (forecastedValue <= 0) forecastedValue = 0;

  let AllValuesArray = [soldValue, commitValue, gapValue];
  let AllValuesArrayTotal = AllValuesArray.reduce((acc, current) => acc + current, 0);
  let total = Math.max(forecastedValue, AllValuesArrayTotal); // Take heighest value for total amoung addition of sold, commit, gap OR forecasted
  let barPxLength = 380;

  let soldPercentage = getConvertedPercentageInPx(soldValue, total, barPxLength, null);
  let commitPercentage = getConvertedPercentageInPx(commitValue, total, barPxLength, null);
  let forecastedPercentage = getConvertedPercentageInPx(forecastedValue, total, barPxLength, null);
  let gapPercentage = getConvertedPercentageInPx(gapValue, total, barPxLength, {
    soldPercentage: soldPercentage,
    commitPercentage: commitPercentage,
  });

  if (parseFloat(forecastedPercentage) < parseFloat(soldPercentage)) {
    soldPercentageWidth = forecastedPercentage;
    soldHashPercentageWidth = soldPercentage - forecastedPercentage;
    commitPercentageWidth = 0;
    CommitHashPercentageWidth = commitPercentage;
  } else if (parseFloat(forecastedPercentage) == parseFloat(soldPercentage)) {
    soldPercentageWidth = soldPercentage;
    soldHashPercentageWidth = 0;
    commitPercentageWidth = 0;
    CommitHashPercentageWidth = commitPercentage;
  } else if (
    parseFloat(forecastedPercentage) > parseFloat(soldPercentage) &&
    parseFloat(forecastedPercentage) < parseFloat(soldPercentage) + parseFloat(commitPercentage) //
  ) {
    soldPercentageWidth = soldPercentage;
    soldHashPercentageWidth = 0;
    commitPercentageWidth = forecastedPercentage - soldPercentage;
    CommitHashPercentageWidth =
      parseFloat(soldPercentage) + parseFloat(commitPercentage) - forecastedPercentage;
  } else if (
    parseFloat(forecastedPercentage) > parseFloat(soldPercentage) &&
    parseFloat(forecastedPercentage) <= parseFloat(soldPercentage) + parseFloat(commitPercentage) //
  ) {
    soldPercentageWidth = soldPercentage;
    soldHashPercentageWidth = 0;
    commitPercentageWidth = commitPercentage;
    CommitHashPercentageWidth = 0;
  } else if (
    parseFloat(forecastedPercentage) > parseFloat(soldPercentage) &&
    parseFloat(forecastedPercentage) > parseFloat(soldPercentage) + parseFloat(commitPercentage) //
  ) {
    soldPercentageWidth = soldPercentage;
    soldHashPercentageWidth = 0;
    commitPercentageWidth = commitPercentage;
    CommitHashPercentageWidth = 0;
  }

  return (
    <CrmChartQuarterlyContainer>
      <CrmChartQuarterlyBar>
        <Bar
          style={{
            width: [soldPercentageWidth] + 'px',
            height: '15px',
            backgroundColor: '#189D3E',
          }}
        />
        <GreenHashBar style={{ width: [soldHashPercentageWidth] + 'px', height: '15px' }} />

        <Bar
          style={{
            width: [commitPercentageWidth] + 'px',
            height: '15px',
            backgroundColor: '#FF9831',
          }}
        />
        <OrangeHashBar style={{ width: [CommitHashPercentageWidth] + 'px', height: '15px' }} />

        <GapBar style={{ width: [gapPercentage] + 'px', height: '15px' }} />
      </CrmChartQuarterlyBar>
      <img
        src={flag}
        alt=" "
        style={{
          height: '47px',
          width: '14px',
          position: 'absolute',
          left: [forecastedPercentage] + 'px',
        }}
      />
    </CrmChartQuarterlyContainer>
  );
}

export function CrmChartDashboard(quarterlyData) {
  const quarterInfo = useRecoilValue(Recoil_Quarter_State);

  let data = quarterlyData.quarterlyData;
  let soldPercentageWidth;
  let soldHashPercentageWidth;
  let commitPercentageWidth;
  let CommitHashPercentageWidth;

  let soldValue = quarterlyData?.quarterlyData?.sold;
  let commitValue = quarterlyData?.quarterlyData?.commit;
  let forecastedValue = quarterlyData?.quarterlyData?.forecast;
  let barPxLength = quarterlyData?.quarterlyData?.barPxLength;
  let gapValue;

  if (!!data && data.period == 'past') {
    if (
      quarterInfo.current_month_start_date == quarterInfo.quarter_start_date ||
      quarterInfo.current_month_end_date == quarterInfo.quarter_end_date ||
      (quarterInfo.current_month_start_date > quarterInfo.quarter_start_date &&
        quarterInfo.current_month_start_date < quarterInfo.quarter_end_date)
    ) {
      //current
      gapValue = Math.abs(forecastedValue - commitValue - soldValue);
    } else {
      //past
      gapValue = Math.abs(forecastedValue - soldValue);
      commitValue = 0;
    }
  } else {
    //future
    gapValue = Math.abs(forecastedValue - commitValue - soldValue);
  }

  if (parseFloat(soldValue) + parseFloat(commitValue) > parseFloat(forecastedValue)) {
    gapValue = 0;
  }

  let AllValuesArray = [soldValue, commitValue, gapValue];
  let AllValuesArrayTotal = AllValuesArray.reduce((acc, current) => acc + current, 0);
  let total = Math.max(forecastedValue, AllValuesArrayTotal); // Take heighest value for total amoung addition of sold, commit, gap OR forecasted

  let soldPercentage = getConvertedPercentageInPx(soldValue, total, barPxLength, null);
  let commitPercentage = getConvertedPercentageInPx(commitValue, total, barPxLength, null);
  let forecastedPercentage = getConvertedPercentageInPx(forecastedValue, total, barPxLength, null);
  let gapPercentage = getConvertedPercentageInPx(gapValue, total, barPxLength, {
    soldPercentage: soldPercentage,
    commitPercentage: commitPercentage,
  });

  if (parseFloat(forecastedPercentage) < parseFloat(soldPercentage)) {
    soldPercentageWidth = forecastedPercentage;
    soldHashPercentageWidth = soldPercentage - forecastedPercentage;
    commitPercentageWidth = 0;
    CommitHashPercentageWidth = commitPercentage;
  } else if (parseFloat(forecastedPercentage) == parseFloat(soldPercentage)) {
    soldPercentageWidth = soldPercentage;
    soldHashPercentageWidth = 0;
    commitPercentageWidth = 0;
    CommitHashPercentageWidth = commitPercentage;
  } else if (
    parseFloat(forecastedPercentage) > parseFloat(soldPercentage) &&
    parseFloat(forecastedPercentage) < parseFloat(soldPercentage) + parseFloat(commitPercentage) //
  ) {
    soldPercentageWidth = soldPercentage;
    soldHashPercentageWidth = 0;
    commitPercentageWidth = forecastedPercentage - soldPercentage;
    CommitHashPercentageWidth =
      parseFloat(soldPercentage) + parseFloat(commitPercentage) - forecastedPercentage;
  } else if (
    parseFloat(forecastedPercentage) > parseFloat(soldPercentage) &&
    parseFloat(forecastedPercentage) <= parseFloat(soldPercentage) + parseFloat(commitPercentage) //
  ) {
    soldPercentageWidth = soldPercentage;
    soldHashPercentageWidth = 0;
    commitPercentageWidth = commitPercentage;
    CommitHashPercentageWidth = 0;
  } else if (
    parseFloat(forecastedPercentage) > parseFloat(soldPercentage) &&
    parseFloat(forecastedPercentage) > parseFloat(soldPercentage) + parseFloat(commitPercentage) //
  ) {
    soldPercentageWidth = soldPercentage;
    soldHashPercentageWidth = 0;
    commitPercentageWidth = commitPercentage;
    CommitHashPercentageWidth = 0;
  }

  return (
    <CrmChartQuarterlyContainer>
      <CrmChartQuarterlyBar>
        <Bar
          style={{
            width: [soldPercentageWidth] + 'px',
            height: '15px',
            backgroundColor: '#189D3E',
          }}
        />
        <GreenHashBar style={{ width: [soldHashPercentageWidth] + 'px', height: '15px' }} />

        <Bar
          style={{
            width: [commitPercentageWidth] + 'px',
            height: '15px',
            backgroundColor: '#FF9831',
          }}
        />
        <OrangeHashBar style={{ width: [CommitHashPercentageWidth] + 'px', height: '15px' }} />

        <GapBarDashboard style={{ width: [gapPercentage] + 'px', height: '15px' }} />
      </CrmChartQuarterlyBar>
      <img
        src={union}
        alt=" "
        style={{
          height: '47px',
          width: '14px',
          position: 'absolute',
          left: [forecastedPercentage] + 'px',
        }}
      />
    </CrmChartQuarterlyContainer>
  );
}
